import { CSpinner } from '@coreui/react-pro';
import { lazy, Suspense } from 'react';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import PrivateRouter, { PrivateRouteProps } from './PrivateRouter';
import PublicRouter, { PublicRouteProps } from './PublicRouter';
// Public pages (checkout, payment callbacks, portals, POS logins) load on demand, so they
// are no longer part of every admin's first download (Admin Portal performance task)
const PageNotFound = lazy(() => import('../pages/private/PageNotFound'));
const Terms = lazy(() => import('../pages/public/Pages/Terms'));
const ResetPassword = lazy(() => import('../pages/public/ResetPassword'));
const VerificationEmail = lazy(() => import('../pages/public/VerificationEmail'));
const VerifyEmail = lazy(() => import('../pages/public/VerifyEmail'));
const HyperPayWidget = lazy(() => import('../hyperPayWidget/HyperPayWidget'));
const PaymentCallBack = lazy(() => import('../hyperPayWidget/paymentCallBack/PaymentCallBack'));
const DeepLinkHandler = lazy(() => import('../mobileModule/DeepLinkHandler'));
const NewCustomerDeepLinkHandler = lazy(() => import('../mobileModule/NewCustomerDeepLinkHandler'));
const Booking = lazy(() => import('../pages/public/Booking'));
const OwnerRegister = lazy(() => import('../pages/public/OwnerRegister'));
const TamaraPaymentCallBack = lazy(() => import('../hyperPayWidget/paymentCallBack/TamaraPaymentCallBack'));
const CustomerPortal = lazy(() => import('../pages/public/CustomerPortal'));
const CustomerCheckout = lazy(() => import('../pages/public/CustomerCheckout'));
const GuestPaymentCallBack = lazy(() => import('../hyperPayWidget/paymentCallBack/GuestPaymentCallBack'));
const RETM_Login = lazy(() => import('../pages/public/RETM'));
const Sajlha_Login = lazy(() => import('../pages/public/Sajlha'));
const FoodicsLogin = lazy(() => import('../pages/public/Foodics'));
const FoodicsCallback = lazy(() => import('../pages/public/Foodics/Callback'));
// Containers
const DefaultLayout = lazy(() => import('../layout/DefaultLayout'));
const SignInPage = lazy(() => import('../pages/public/SignIn'));
const TransactionDetailsPage = lazy(() => import('../pages/public/TransactionDetails'));
const OtpPage = lazy(() => import('../pages/public/OtpScreen'));
const ForgotPasswordPage = lazy(() => import('../pages/public/ForgotPassword'));
// const ResetPasswordPage = lazy(() => import('../pages/public/ResetPassword'))
// const VerificationEmail = lazy(() => import('../pages/public/VerificationEmail'))
// const VerifyEmail = lazy(() => import('../pages/public/VerifyEmail'))

const IndexRouter = () => {
  return (
    <Suspense
      fallback={
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
                }}
        >
          <CSpinner color="primary" />
        </div>
      }
    >
      <Router>
        <Routes>
          <Route path="/retm-integration" element={<RETM_Login />} />
          <Route path="/sajlha-integration" element={<Sajlha_Login />} />
          <Route path="/foodics-integration" element={<FoodicsLogin />} />
          <Route path="/foodics-integration/callback" element={<FoodicsCallback />} />
          <Route path="/transaction-details" element={<TransactionDetailsPage />} />

          <Route path="/paymentCallBack" element={<HyperPayWidget />} />
          <Route path="/checkout" element={<CustomerCheckout />} />

          <Route path="/checkPaymentStatus" element={<PaymentCallBack />} />
          <Route path="/guest/checkPaymentStatus" element={<GuestPaymentCallBack />} />
          <Route path="/checkTamaraPaymentStatus" element={<TamaraPaymentCallBack />} />

          <Route path="/deepLinkHandler" element={<DeepLinkHandler />} />
          <Route path="/download-app" element={<NewCustomerDeepLinkHandler />} />
          <Route path="/booking" element={<Booking />} />
          <Route path="/bbreg/:providerID" element={<OwnerRegister />} />
          
          <Route
            path="/signin"
            element={<PublicRouter {...defaultPublicRouteProps} outlet={<SignInPage />} />}
          />

          <Route
            path="/otp"
            element={<PublicRouter {...defaultPublicRouteProps} outlet={<OtpPage />} />}
          />

          <Route
            path="/forgot-password"
            element={<PublicRouter {...defaultPublicRouteProps} outlet={<ForgotPasswordPage />} />}
          />

          <Route path="/verification">
            <Route
              path="email"
              element={<PublicRouter {...defaultPublicRouteProps} outlet={<VerificationEmail />} />}
            />

            <Route path="*" index element={<PageNotFound />} />
          </Route>

          <Route path="/terms" element={<Terms />} />

          <Route path="/verify-email">
            <Route index element={<PageNotFound />} />

            <Route path="*" element={<VerifyEmail />} />
          </Route>

          <Route path="/reset-password">
            <Route index element={<PageNotFound />} />
            <Route
              path="*"
              // element={<PublicRouter {...defaultPublicRouteProps} outlet={<ResetPasswordPage />} />}
              element={<ResetPassword />}
            />
          </Route>

          <Route
            path="*"
            element={<PrivateRouter {...defaultPrivateRouteProps} outlet={<DefaultLayout />} />}
          />
        </Routes>
      </Router>
    </Suspense>
  );
};

export default IndexRouter;

const defaultPublicRouteProps: Omit<PublicRouteProps, 'outlet'> = {
  authenticatedPath: '/',
};

const defaultPrivateRouteProps: Omit<PrivateRouteProps, 'outlet'> = {
  authenticationPath: '/signin',
};
